import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosGet from "../axios/axios-get";

export const CategoriesAPI = Object.freeze({
  getAll: createAsyncThunk("get/get-categories", async (params) => {
    return await axiosGet.get(`/categories?top=false`, { params });
  }),

  getOne: createAsyncThunk("get/one-category", async (id) => {
    return await axiosGet.get(`/category/${id}`);
  }),

  create: createAsyncThunk("post/post-category", async (data) => {
    return await axiosGet.post("/category", data);
  }),

  update: createAsyncThunk("put/put-category", async (data) => {
    return await axiosGet.put(`/category/${data.id}`, data);
  }),

  delete: createAsyncThunk("delete/delete-category", async (id) => {
    return await axiosGet.delete(`/category/${id}`);
  }),
});
